
import { Box, Modal } from "@mui/material";
import Button from "@mui/material/Button";
import React, { useState, useRef, useEffect } from "react";
import * as XLSX from "xlsx";
import DeleteIcon from "@mui/icons-material/Delete";
import _ from "lodash";
import sampleProjectFile from "../../assests/document/bulk_project_temp.xlsx";
import AlertComponent from "../alert/alert";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const BulkUploadModal = (props) => {
  const [openBulkUploadModal, setOpenBulkUploadModal] = React.useState(false);
  const [openDefaulfFields, setOpenDefaulfFields] = React.useState(false);
  const [openImportInitiated, setOpenImportInitiated] = React.useState(false);
  const [fileInput, setFileInput] = useState([]);
  const [fileData, setFileData] = useState(null);
  const [createTableArr, setCreateTableArr] = useState(props?.createTableArr);
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  useEffect(() => {
    setOpenBulkUploadModal(props?.openBulkUploadModal);
  }, [props?.openBulkUploadModal]);

  useEffect(() => {
    setCreateTableArr(props?.createTableArr);
  }, [props?.createTableArr]);

  useEffect(() => {
    setOpenDefaulfFields(props?.openDefaulfFields);
  }, [props?.openDefaulfFields]);

  const closeCreateProject = () => {
    props?.setOpenBulkUploadModal(false);
    setFileInput([]);
    setFileData(null);
  };
  const handleClose = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };
  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };
  const onImport = () => {
    if (fileInput.length < 1) {
      openAlert(true, "error", `Please select valid excel file.`);
      return;
    }
    props?.setOpenBulkUploadModal(false); 
    const updatedCreateTableArr = createTableArr.map(item => ({
      ...item,
      // value: "",
      // errMsg: ''
    }));
    setCreateTableArr(updatedCreateTableArr);
    onsetOpenDefaulfFields(true);

  };

  const openCreateEmpSelectChange = (e, ele, i) => {
    let createTableArrInit = _.cloneDeep(createTableArr);
    createTableArrInit[i].value = e.target.value;
    setCreateTableArr(createTableArrInit);
    createTableArrInit[i].errMsg = '';
  };


  const handleFileChange = (event) => {
    const file = event.target.files[0];
    let sFilename = file.name;
    let reader = new FileReader();
    let result = {};

    reader.onload = function (e) {
      let data = e.target.result;
      data = new Uint8Array(data);
      let workbook = XLSX.read(data, { type: "array" });
      let result = {};
      workbook.SheetNames.forEach(function (sheetName) {
        let roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
          header: 1,
        });
        if (roa.length) result[sheetName] = roa;
      });
      setFileInput(result?.Sheet1[0]);
      setFileData(file);
    };
    reader.readAsArrayBuffer(file);
  };

  const handleDelete = () => {
    setFileInput([]);
    setFileData(null);

    document.getElementById("fileInput").value = "";
  };

  const onBulkUploadSubmit = () => {
    props.onBulkUploadSubmit(fileData, createTableArr);
  };


  const onsetOpenDefaulfFields = (param) => {
    props.onsetOpenDefaulfFields(param);
  };

  const handleDownload = () => {
    if (props.sampleProjectFile) {
      const link = document.createElement('a');
      link.href = props.sampleProjectFile;
      link.download = 'Sample-file';
      link.click();
    } else {
      const link = document.createElement('a');
      link.href = sampleProjectFile;
      link.download = 'Sample-file';
      link.click();
    }
  };

  const isDeleteDisabled = !fileInput;


  return (
    <>
      {/* Delete Modal */}
      {/* First Import Modal Create Employee */}
      <Modal
        open={openBulkUploadModal}
        onClose={closeCreateProject}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal_react_controlpanel_employee">
          <div className="modal-header">
            <h5 className="modal-titles" id="uploadexcelfileLabel">

              {props.title ? props.title : "Create Project (Upload Excel File)"}
            </h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={closeCreateProject}
            ></button>
          </div>
          <div className="modal-body lets_modal_body_block_listing">
            <div id="vendorForm">
              <div className="lets_modal_vendor2">
                <p>Upload Excel Template</p>
                <div className="master_panel_icon_react">
                  <input
                    className="form-control form-h choose"
                    type="file"
                    id="fileInput"
                    accept=".xlsx, .xls"
                    onChange={handleFileChange}
                  />

                  <DeleteIcon
                    className={`delete_icon_btn_panel_react ${isDeleteDisabled ? "disabled" : ""
                      }`}
                    style={{ color: isDeleteDisabled ? "grey" : "red" }}
                    onClick={handleDelete}
                    disabled={isDeleteDisabled}
                  />

                </div>
                <span onClick={handleDownload} style={{ cursor: 'pointer', fontWeight: '600', color: '#0d6efd' }}>Download sample File</span>
                <div className="clear_btn_status">

                  <button
                    type="button"
                    className=" btn btn-warning"
                    data-dismiss="modal"
                    fdprocessedid="3pe65"
                    onClick={closeCreateProject}
                  >
                    Close
                  </button>
                  <button
                    // style={{ color: isDeleteDisabled ? "grey" : "red" }}
                    // disabled={isDeleteDisabled}
                    type="button"
                    className="btn btn-success"
                    fdprocessedid="sqi0b"
                    onClick={onImport}
                  >
                    Import
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>

      {/* Table Modal Create Employee */}
      <Modal
        open={openDefaulfFields}
        onClose={() => onsetOpenDefaulfFields(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal_react_controlpanel_employee">
          <div className="modal-header">
            <h5 className="modal-titles" id="uploadexcelfileLabel">
              {props.title ? props.title : "Create Project"}
            </h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => onsetOpenDefaulfFields(false)}
            ></button>
          </div>
          <div className="modal-body">
            <p className="field_ptag_body">Defaulf Fields</p>
            <div className="vendor_configuration_list_block" style={{ maxHeight: "390px" }}>
              <table className="table" id="employeeTable">
                <thead>
                  <tr>
                    <th className="vendor_tabels">LIST OF FIELDS</th>
                    <th className="vendor_tabels">COLUMNS IN EXCEL FILE</th>
                  </tr>
                </thead>
                <tbody>
                  {createTableArr.map((ele, i) => (
                    <>
                      <tr>
                        <td>{ele?.label}</td>
                        <td>
                          <select
                            className="form-select employeecreation"
                            name="role[]"
                            value={ele?.value}
                            onChange={(e) =>
                              openCreateEmpSelectChange(e, ele, i)
                            }
                          >
                            <option value="" disabled={true}>
                              Please Select
                            </option>
                            {fileInput.map((optionData, j) => (
                              <>
                                <option value={optionData}>
                                  {optionData}
                                </option>
                              </>
                            ))}
                          </select>
                          <span id="businessNameError" className="error">
                            {ele?.errMsg}
                          </span>
                        </td>
                      </tr>
                    </>
                  ))}
                </tbody>
              </table>
              <div className="clear_btn_status">
                <button
                  type="button"
                  className="clear_btn_status_block_list_btnclose"
                  onClick={() => onsetOpenDefaulfFields(false)}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-success save_next_btn"
                  onClick={onBulkUploadSubmit}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleClose}
      />
    </>
  );
};

export default BulkUploadModal;